class MediaGalleryCustom {
  constructor(sectionId) {
    this.mainSldierSelector = `#MainProduct-${sectionId} .product-media-main`;
    this.thumbSldierSelector = `#MainProduct-${sectionId} .product-media-thumbs`;
    this.relatedSldierSelector = `#MainProduct-${sectionId} .related_product_blocks`;
    this.relatedSldierSingleSelector = `#MainProduct-${sectionId} .related_product_blocks .related_product_single`;

    this.mainSliderConfig = {
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      infinite: true,
      arrows: true,
      dots: false,
      speed: 300,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            arrows: true,
            dots: true,
          },
        },
      ],
    };

    this.thumbSliderConfig = {
      slidesToShow: 3,
      slidesToScroll: 1,
      swipeToSlide: true,
      dots: false,
      arrows: true,
      infinite: true,
      asNavFor: this.mainSldierSelector,
      centerMode: true,
      focusOnSelect: true,
      speed: 300,
    };

    this.relatedSldierConfig = {
      slidesToShow: 5.3,
      swipeToSlide: true,
      infinite: false,
      arrows: true,
      dots: false,
      variableWidth: false,
      infinite: false,
      speed: 300,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4.3,
            variableWidth: false,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3.3,
            variableWidth: false,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          },
        },
      ],
    };

    this.mainSlider;
    this.thumbsSlider;
    this.relatedSldier;
    this.contentVisible = true;
    this.init();
  }
  init() {
    this.sliders();
    this.showMoreLess();
    this.fancybox();
  }

  sliders() {
    const childrenCount = $(this.mainSldierSelector).children().length;
    if (childrenCount > 1) {
      if (childrenCount > 3) {
        this.mainSliderConfig.asNavFor = this.thumbSldierSelector;
        this.thumbsSlider = $(this.thumbSldierSelector).slick(
          this.thumbSliderConfig
        );
      }
      this.mainSlider = $(this.mainSldierSelector).slick(this.mainSliderConfig);
    }
    if (childrenCount <= 3) {
      $("img", $(this.thumbSldierSelector)).on("click", (e) => {
        console.log("first", e.target.dataset.index);
        this.mainSlider.slick("slickGoTo", e.target.dataset.index);
      });
    }

    const related_childrenCount = $(this.relatedSldierSingleSelector).length;
    if (related_childrenCount > 2) {
      this.relatedSldier = $(this.relatedSldierSelector).slick(
        this.relatedSldierConfig
      );
    }
  }

  showMoreLess() {
    document.querySelectorAll(".toggle_show_more").forEach((btn) => {
      if (btn.dataset.toggleBound === "1") return;
      btn.dataset.toggleBound = "1";

      let desc = btn.closest(".product__description");
      desc.querySelector(".show_more")?.classList.add("hidden");
      desc.querySelector(".show_less")?.classList.remove("hidden");
      btn.textContent = btn.dataset.more;
      let expanded = false;

      btn.addEventListener("click", () => {
        expanded = !expanded;
        btn.textContent = expanded ? btn.dataset.less : btn.dataset.more;
        desc.querySelector(".show_more")?.classList.toggle("hidden");
        desc.querySelector(".show_less")?.classList.toggle("hidden");
      });
    });
  }

  fancybox() {
    Fancybox.bind('[data-fancybox="gallery"]', {
      compact: false,
      idle: false,

      animated: false,
      showClass: false,
      hideClass: false,

      dragToClose: false,
      contentClick: false,

      Images: {
        // Disable animation from/to thumbnail on start/close
        zoom: false,
      },

      Toolbar: {
        display: {
          left: [],
          middle: [],
          right: ["close"],
        },
      },

      Thumbs: false,
    });
  }
}
